module.exports = __webpack_public_path__ + "img/curved8.2e986c7d.jpg";